// https://github.com/ngx-formly/ngx-formly/issues/2558

import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'select-tooltip',
  template: `
    <mat-form-field
      class="fill"
      [class.mat-form-field-invalid]="formControl.errors && formControl.touched"
    >
      <mat-label [innerText]="to.label"></mat-label>
      <mat-select
        [formlyAttributes]="field"
        [(ngModel)]="value"
        (selectionChange)="selectionChange($event)"
      >
        @for (item of to.options | formlySelectOptionsTooltip | async; track item) {
          <mat-option [value]="item.value" [matTooltip]="item.tooltip!">{{
            item.label
          }}</mat-option>
        }
      </mat-select>
      @if (formControl.errors && (formControl.dirty || formControl.touched)) {
        <mat-error>
          <formly-validation-message [field]="field"></formly-validation-message>
        </mat-error>
      }
    </mat-form-field>
  `,
  standalone: false,
})
export class FormlySelectTooltipComponent extends FieldType implements OnInit {
  public value = undefined;

  ngOnInit(): void {
    this.formControl.valueChanges.subscribe((res: any) => {
      if (res === null) {
        this.value = undefined;
      }
    });
  }

  selectionChange(event) {
    this.formControl.patchValue(event.value);
  }
}
